import type { ThemeConfig } from "@/lib/types"

const config: ThemeConfig = {
  name: "naturstore",
  displayName: "Natur' Store",
  themeColor: "#1e1d1d",
  features: {
    wishlist: false,
    reviews: false,
    guestCheckout: true,
    newsletter: true,
    contactForm: true,
    productCompare: false,
    socialProof: false,
    loyalty: true,
    productZoom: false,
    events: true,
    consultations: true,
    trustSignals: false,
  },
  metadata: {
    description: "Essential natural products curated for the modern lifestyle",
    defaultOgImage: "/themes/naturstore/assets/og-image.png",
  },
  announcement: {
    enabled: true,
    // Show the bar only while the channel is pickup-only (no delivery carrier).
    // The instant a delivery carrier is re-activated (mixed mode), the layout
    // stops rendering it — no copy edit, no flip-back checklist step.
    showWhen: "collectionOnly",
    // `messageKey` resolves the localized line from the `layout` namespace
    // (themes/naturstore/messages/{en,de,fr}.json → layout.announcement) so the
    // bar reads natively per locale. `message` is the SSR-safe English fallback
    // and the stable basis for the per-message dismissal key.
    messageKey: "announcement",
    message: "Online orders are currently available for collection at our Wickrange boutique.",
  },
  // Delivery destinations (owner decision 2026-09: Austria dropped). The DPD /
  // POST carrier's Austria rate must also be cleared in the admin.
  shipping: {
    countries: ["LU", "FR", "DE", "BE", "NL"],
  },
  featuredHighlight: {
    urlKey: "the-house-cologne-limited-edition",
    imageRight: true,
  },
  hero: {
    slides: [],
  },
}

export default config
